import { render } from "./TabFilter.vue?vue&type=template&id=0d2a4a4f&scoped=true&ts=true"
import script from "./TabFilter.vue?vue&type=script&lang=ts"
export * from "./TabFilter.vue?vue&type=script&lang=ts"

import "./TabFilter.vue?vue&type=style&index=0&id=0d2a4a4f&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2a4a4f"]])

export default __exports__